import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'login',
      path: '/login',
      component: () => import('@/view/login'),
    },
    {
      name: 'home',
      path: '/home',
      component: () => import('@/view/home/index')

    },
    {
      name: 'my',
      path: '/my',
      component: () => import('@/view/my/index'),
    },
    {
      name: 'search',
      path: '/search',
      component: () => import('@/view/search/index'),
    },
    {
      name: 'details',
      path: '/details',
      component: () => import('@/view/details/index'),
    },
    {
      name: 'collectonlist',
      path: '/collectonlist',
      component: () => import('@/view/collectionlist/index'),
    },
    {
      name: 'myassets',
      path: '/myassets',
      component: () => import('@/view/myassets/index'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js